import React, { Component } from 'react';
import _ from 'lodash';
import {
  // string,
  func
  // object
} from 'prop-types';

import * as QuizHelpers from '../../helpers/quiz';

class Family extends Component {
  state = {
    animate: ''
  }

  componentDidMount () {
    this.props.toggleInQuiz(true);
    this.props.toggleInResults(false);
    this.props.updateResultsRatings(false, {});
    this.props.updateResultsFooter(false, {});
    this.props.setFieldValue('QuizRoute', `${this.props.route}`);
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleSelectFamily (famType, originalFamilyType) {
    const {quiz, route, stepMethods, updateQuote} = _.clone(this.props);
    let nextStep = parseFloat(quiz.step) + 1;
    updateQuote('families');
    this.props.reducer(famType, originalFamilyType);
    stepMethods.setStep(nextStep);

    QuizHelpers.sendAnalyticsOnQuestion(`${route}`, 'Family');
  }

  _handleSelectCHP (famType, originalFamilyType) {
    const {quiz, stepMethods, updateQuote} = _.clone(this.props);
    let nextStep = parseFloat(quiz.step) + 1;
    updateQuote('child-health-plus');
    this.props.reducer(famType, originalFamilyType);
    stepMethods.setStep(nextStep);

    if (this.props.route !== 'child-health-plus') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'visitorType': 'Prospect - CHP'
      });
    }
  }

  render () {
    // MAKE SURE YOU SEND (FamilyType, true) TO THE REDUCER SO IT STORES OriginalFamilyType
    return (
      <section className={'p30 animate ' + this.state.animate}>
        <div className='wrap families'>
          <h3>Who’s the plan for?</h3>
          <ul className='user four'>
            <li><a
              className='couple'
              onClick={(e) => this._handleSelectFamily('Couple', true)}
            ><span>Me &amp; My Spouse</span></a></li>
            <li><a
              className='family'
              onClick={(e) => this._handleSelectFamily('CoupleChildren', true)}
            ><span>Me, My Spouse &amp; My Kid(s)</span></a></li>
            <li><a
              className='withkids'
              onClick={(e) => this._handleSelectFamily('IndividualChildren', true)}
            ><span>Me &amp; My Kid(s)</span></a></li>
            <li><a
              className='children'
              onClick={(e) => this._handleSelectCHP('ChildrenOnly', true)}
            ><span>My Kid(s) Only</span></a></li>
          </ul>
        </div>
      </section>
    );
  }
}

Family.propTypes = { // validate props expected from the parent
  'reducer': func.isRequired
};

export default Family;
